import { ScriptService } from './../../../../services/cms/script.service';
import { ValidationService } from './../../../../services/core/validation.service';
//Angular
import { Component, OnInit, ViewContainerRef, ChangeDetectionStrategy, ViewEncapsulation, EventEmitter, Output, Compiler, Inject, Renderer } from "@angular/core";

//Services
import { ClientAreaService } from "./../../../../services/settings/client-area.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { AuthService } from "./../../../../services/core/auth.service";
import { RoutesService } from "../../../../services/core/routes.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
import { Router } from "@angular/router";

//Models
import { ClientAreaUserProfile } from "./../../../../models/settings/client-area";
import { ClientAreaUserAddress } from "./../../../../models/settings/client-area";
import { Register } from "./../../../../models/cms/register";
import { Company } from "./../../../../models/core/company";
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ""
})
export class ClientAreaProfileComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private clientAreaService: ClientAreaService,
        private router: Router,
        private authService: AuthService,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any
        ) { }

    private authentication: any = this.authService.GetData();
    private userId = this.authService.GetUserId();

    subManager = new Subscription();

    ngOnInit() {
        if (!this.authService.GetData().isAuthenticated) {
            this.router.navigate([""]);
        }
        let templateHtmlUserProfile: string;
        let header: any;
        let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
            header = result;
            header = result;
            let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        let userProfileSub = this.clientAreaService.getUserAreaProfile(this.userId).subscribe(result => {

            templateHtmlUserProfile = result;
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(templateHtmlUserProfile, header);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);

        })

        this.subManager.add(userProfileSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(userProfile: any, header: any) {
        @Component({
            template: userProfile.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private clientAreaService: ClientAreaService,
                    private languageService: LanguageService,
                    private authService: AuthService,
                    private routesService: RoutesService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private seoService: SeoService,
                    private breadcrumbsService: BreadcrumbsService,
                    private validationService: ValidationService,
                    private scriptService: ScriptService
                ) { }

            @Output() onCreate = new EventEmitter();

            model = {
                UserId: 0,
                Address: "",
                City: "",
                Prov: "",
                Cap: "",
                CompanyName: "",
                Piva: "",
                TaxCode: "",
                Name: "",
                SubName: "",
                Telephone: "",
                Mobile: "",
                CF: "",
                PecEmail: "",
                CodiceDestinatario: "",
                CurrentPassword: "",
                Password: "",
                PasswordRepeat: "",
                AddressRadio: "",
                Language: "",
                AddressNumber: "",
                DefaultAddress: 999999
            }

            modelAddAndRemoveAddress = {
                UserId: "",
                AddressId: ""
            }

            footerData: any = userProfile.footerData;
            headerData: any = header;

            private clientAreaProfile: ClientAreaUserProfile = new ClientAreaUserProfile();
            private addresses: ClientAreaUserAddress[] = [];
            private clientAddress: ClientAreaUserAddress = new ClientAreaUserAddress();
            private company: Company = new Company();
            private register: Register = new Register();
            private authentication: any = this.authService.GetData();
            private updateSuccessful: boolean;
            private updateFailed: boolean;
            private updateAddressFailed: boolean;
            private updateAddressSuccessful: boolean;
            private changePasswordSuccessful: boolean;
            private changePasswordFailed: boolean;
            private id1: number;
            private isExist: boolean[] = [];
            private index: number;
            private item: any;
            private pageIsInit: boolean = false;
            private userId = this.authService.GetUserId();
            private decryptedUserId = this.authService.GetDecryptedUserId();
            private user = userProfile.ClientAreaUserProfile;
            private userGroup: any = this.user.UserGroup;
            private showSpinnerClick: boolean = false;

            private breadcrumbs: Breadcrumbs[] = userProfile.BreadcrumbsInfo;

            private pageIsOnDestroy: boolean = false;
            private areaClientiHome: string[] = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
            private areaClientiOrdini: string[] = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
            private areaChangeProfile: string[] = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
            private areaClientiInvoices: string[] = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
            private areaClientiCatalogoRiservato: string[] = this.routesService.getRoutePath('RESERVED - CATALOG');
            private isActiveInvoicesModule: boolean = userProfile.isActiveInvoicesModule;
            private isCatalogPrivateActive: boolean = userProfile.isCatalogPrivateActive;
            subManager = new Subscription();

            ngOnInit() {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                this.clientAreaProfile = this.user;

                //spliting address street and number
                let address = this.clientAreaProfile.Address;
                let lastIndex = -1;
                if (address) {
                    lastIndex = address.lastIndexOf(" ");
                }
                let addressStreet: string = "";
                let addressNumber: string = "";

                if (lastIndex > -1) {
                    addressStreet = address.slice(0, lastIndex);
                    addressNumber = address.slice(lastIndex, address.length).trim();
                }

                this.model.CompanyName = this.user.CompanyName;
                this.model.Piva = this.user.Piva;
                this.model.TaxCode = this.user.TaxCode;
                this.model.Name = this.user.ContactFirstName;
                this.model.SubName = this.user.ContactLastName;
                this.model.Address = addressStreet;
                this.model.AddressNumber = addressNumber;
                this.model.City = this.user.City;
                this.model.Prov = this.user.AreaCode;
                this.model.Cap = this.user.ZipCode;
                this.model.Telephone = this.user.ContactPhone;
                this.model.DefaultAddress = this.user.DefaultAddressId;
                this.model.Mobile = this.user.ContactMobile;
                this.model.PecEmail = this.user.PecEmail;
                this.model.CodiceDestinatario = this.user.CodiceDestinatario;

                this.id1 = this.user.DefaultAddressId;

                for (var key in this.clientAreaProfile.Addresses) {
                    this.isExist[this.clientAreaProfile.Addresses[key].AddressId] = true;
                }

                // if user group is 4, pec email and cod. destinatario are not required
                if (this.userGroup == 4) {

                }
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                if (userProfile.isActiveAddressVerificationModule) {
                    let addressVerificationKey = userProfile.AddressVerificationCode;
                    if (addressVerificationKey != null && addressVerificationKey != undefined && addressVerificationKey != "") {
                        this.addAddressVerificationScripts(addressVerificationKey);
                        $("#Cap").prop('disabled', true);
                    }
                }
                else {
                    $("#Cap").prop('disabled', false);
                }

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                this.pageIsInit = true;
            }

            isCodDestRequired() {
                let retVal = false;
                if (this.userGroup != "4") {
                    if (this.model.PecEmail == "" || this.model.PecEmail == undefined) {
                        retVal = true;
                    }
                }

                return retVal;
            }

            isPecEmailRequired() {
                let retVal = false;
                if (this.userGroup != "4") {
                    if (this.model.CodiceDestinatario == "" || this.model.CodiceDestinatario == undefined) {
                        retVal = true;
                    }
                }

                return retVal;
            }

            //adding all scripts and elements connected to address verification feature                
            addAddressVerificationScripts(addressKey: string) {
                let suggest = "<script type=\"text/javascript\" id=\"suggestId\" src=\"/template/b2c/template01/layout/js/suggest.js\"></script>";
                let address = "<script id=\"addressVerificationId\" type=\"text/javascript\" title=" + addressKey + " src=\"/template/b2c/template01/layout/js/adress-verification.js?v=1\"></script>";
                let jquery = "<script type=\"text/javascript\" id=\"jqueryId\" src=\"/template/b2c/template01/layout/vendor/jquery/jquery.min.js\"></script>";

                $('body > universal-script').before(suggest);
                $('body > universal-script').before(jquery);
                $('body > universal-script').before(address);
            }


            //removing all scripts and elements connected to address verification feature                            
            removeAddressVerificationScripts(addressKey: string) {
                $("#suggestId").remove();
                $("#jqueryuicss").remove();
                $("#jqueryuijs").remove();
                $("#suggestcss").remove();
                $("#initui").remove();
                $("#inituicf").remove();
                $("#ui-id-1").remove();
                $("#ui-id-2").remove();
                $("div").remove(".ui-helper-hidden-accessible");

                $("#jqueryId").remove();
                $("#addressVerificationId").remove();
            }

            checkAddressValidation() {
                this.model.Prov = $("#Prov").val();
                this.model.Cap = $("#Cap").val();
                this.model.City = $("#City").val();
            }

            //validation of phone numbers, disable writing any characters in input except of numbers
            validatePhone(event: any) {
                this.validationService.validatePhoneNumber(event);
            }

            setAddressValue() {
                let streetTypeId = $("#streetTypeId").val();
                let street = $("#Address").val();

                if (streetTypeId != null && streetTypeId != "") {
                    this.model.Address = streetTypeId + " " + street;
                }
                else {
                    this.model.Address = street;
                }

                let cap = $("#Cap").val();
                this.model.Cap = cap;
            }

            changeUserProfile(valid, model) {
                model.UserId = this.authService.GetUserId();

                let street = this.model.Address;

                //concating of address street and number to one model field
                this.model.Address = this.model.Address + " " + this.model.AddressNumber.replace(/\s/g, "");
                this.showSpinnerClick = true;
                let updateProfileSub = this.clientAreaService.updateUserProfile(model).subscribe(result => {
                    if (result) {
                        // show success message
                        this.updateSuccessful = true;
                        this.updateFailed = false;
                    }
                    else {
                        // show error message
                        this.updateSuccessful = false;
                        this.updateFailed = true;
                    }

                    this.model.Address = street;
                    this.showSpinnerClick = false;
                });
                this.subManager.add(updateProfileSub);
            };

            showModal(index, item) {
                $("#editProfileModal").modal("show");
                this.index = index;
                this.item = item;
            }

            hideModal() {
                $('#editProfileModal').modal('hide');
            }

            addNewAddress() {
                this.modelAddAndRemoveAddress.UserId = this.userId;

                let newAddressSub = this.clientAreaService.addNewAddress(this.modelAddAndRemoveAddress).subscribe(result => {
                    this.clientAreaProfile.Addresses.push(result);

                    let userProfileSub = this.clientAreaService.getUserAreaProfile(this.userId).subscribe(result => {
                        this.clientAreaProfile = result.ClientAreaUserProfile;
                        this.model.CompanyName = result.ClientAreaUserProfile.CompanyName;
                        this.model.Piva = result.ClientAreaUserProfile.Piva;
                        this.model.TaxCode = result.ClientAreaUserProfile.TaxCode;
                        this.model.Name = result.ClientAreaUserProfile.ContactFirstName;
                        this.model.SubName = result.ClientAreaUserProfile.ContactLastName;
                        this.model.Address = result.ClientAreaUserProfile.Address;
                        this.model.City = result.ClientAreaUserProfile.City;
                        this.model.Prov = result.ClientAreaUserProfile.AreaCode;
                        this.model.Cap = result.ClientAreaUserProfile.ZipCode;
                        this.model.Telephone = result.ClientAreaUserProfile.ContactPhone;
                        this.model.DefaultAddress = result.ClientAreaUserProfile.DefaultAddressId;
                        this.model.Mobile = result.ClientAreaUserProfile.ContactMobile;
                        this.model.PecEmail = result.ClientAreaUserProfile.PecEmail;
                        this.model.CodiceDestinatario = result.ClientAreaUserProfile.CodiceDestinatario;
                        this.id1 = result.ClientAreaUserProfile.DefaultAddressId;

                        for (var key in this.clientAreaProfile.Addresses) {
                            this.isExist[this.clientAreaProfile.Addresses[key].AddressId] = true;
                        }
                    });

                    this.subManager.add(userProfileSub);
                });

                this.subManager.add(newAddressSub);
            }

            SubmitPassword(model) {
                model.UserId = this.userId;
                this.showSpinnerClick = true;
                let updatePassSub = this.clientAreaService.updateUserPassword(model).subscribe(result => {
                    if (result == true) {
                        this.changePasswordSuccessful = true;
                        this.changePasswordFailed = false;
                    }
                    else {
                        // show error message
                        this.changePasswordSuccessful = false;
                        this.changePasswordFailed = true;
                    }
                    this.showSpinnerClick = false;
                })

                this.subManager.add(updatePassSub);
            }

            setDefaultAddress(index, item) {
                this.clientAreaProfile.DefaultAddressId = 0;

                for (var address of this.clientAreaProfile.Addresses) {
                    if (address.AddressId === this.clientAreaProfile.Addresses[index].AddressId) {
                        this.clientAreaProfile.DefaultAddressId = address.AddressId;
                    }

                    this.id1 = this.clientAreaProfile.DefaultAddressId;
                }
            };

            resetAddress() {
                for (var address of this.clientAreaProfile.Addresses) {
                    this.clientAreaProfile.DefaultAddressId = 0;
                    this.id1 = 0;
                };
            };

            updateUserAddresses(model, valid, item) {
                this.showSpinnerClick = true;
                let updateAddressSub = this.clientAreaService.updateAddresses(this.clientAreaProfile.Addresses, this.userId, this.clientAreaProfile.DefaultAddressId)
                    .subscribe(result => {
                        let defaultFound = false;

                        if (result) {
                            for (var address of this.clientAreaProfile.Addresses) {
                                if (this.clientAreaProfile.DefaultAddressId > 0) {
                                    this.clientAreaProfile.DefaultAddressId = address.AddressId;
                                    defaultFound = true;
                                }
                            }

                            this.updateAddressFailed = false;
                            this.updateAddressSuccessful = true;
                        }
                        else {
                            this.updateAddressFailed = true;
                            this.updateAddressSuccessful = false;
                        }

                        if (defaultFound == false) {
                            this.clientAreaProfile.DefaultAddressId = 0;
                        }
                        this.showSpinnerClick = false;
                    })

                this.subManager.add(updateAddressSub);
            };

            removeAddress() {
                this.modelAddAndRemoveAddress.UserId = this.userId;
                this.modelAddAndRemoveAddress.AddressId = this.item.AddressId;

                let removeAddressSub = this.clientAreaService.removeAddress(this.modelAddAndRemoveAddress).subscribe(result => {
                    this.clientAreaProfile.Addresses.splice(this.index, 1);
                    try {
                        this.isExist[this.item.AddressId] = false;

                        this.model.DefaultAddress = 0;
                        this.id1 = 0;
                        this.resetAddress();
                        this.hideModal();
                    }
                    catch (exception) { }
                });

                this.subManager.add(removeAddressSub);
            };

            isDisabled(form) {
                let res: boolean = false;

                if (form.valid && this.model.Password.length >= 4 && this.model.Password.length <= 10 && this.model.Password == this.model.PasswordRepeat) {
                    return true;
                }
                else {
                    return res;
                }
            }
            getClassforMenuClientArea()
            {
              let result;
              if(this.isActiveInvoicesModule&&this.isCatalogPrivateActive)
              {
                result="col-md-3 col-sm-3"
              }
              else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
                result = "col-md-3 col-sm-3"
              }
              else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
                result = "col-md-4 col-sm-4"
              }
              return result
            }
            ngOnDestroy() {
                if (!this.isBrowser || this.pageIsOnDestroy) {
                    return;
                }

                //this method is removing all scripts and elements connected to address verification feature
                let addressVerificationKey = userProfile.AddressVerificationCode;
                this.removeAddressVerificationScripts(addressVerificationKey);

                this.subManager.unsubscribe();
                this.pageIsOnDestroy = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/client-area/sys/client-area-profile.component.ts